export interface EmailPayload {
    subject: string;
    greeting: string;
    body: string;
    signOff: string;
}

export function readEmailPayload(value: unknown): EmailPayload | null {
    if (!value || typeof value !== "object" || Array.isArray(value)) return null;
    const payload = value as Record<string, unknown>;
    const fields = ["subject", "greeting", "body", "signOff"] as const;
    if (fields.some((field) => payload[field] !== undefined && typeof payload[field] !== "string")) return null;
    if (typeof payload.subject !== "string" && typeof payload.body !== "string") return null;
    return Object.fromEntries(fields.map((field) => [field, payload[field] ?? ""])) as unknown as EmailPayload;
}

export function emailPlainText(payload: EmailPayload, subjectLabel: string): string {
    return [`${subjectLabel}: ${payload.subject}`, "", payload.greeting, "", payload.body, "", payload.signOff].join("\n");
}
